import { FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { isErrorOfVsApi } from '../errorHelper';
import { RtkErrorResponseOfVsApi } from '../type';

type PossibleFetchArgs = FetchArgs | string;

export class VsApiError extends Error {
  public override name: string;
  public override cause?: RtkErrorResponseOfVsApi['data'] | FetchBaseQueryError;
  fetchArgs: PossibleFetchArgs;
  status: FetchBaseQueryError['status'];

  constructor(
    error: RtkErrorResponseOfVsApi | FetchBaseQueryError,
    args: PossibleFetchArgs,
    subName?: string
  ) {
    if (isErrorOfVsApi(error)) {
      super(
        `Request failed with status code ${error.data.status_code}: ${error.data.message}.`
      );
    } else {
      super(`Request failed with status ${error.status}.`);
    }

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, VsApiError);
    }

    this.name = `VsApiError${subName ? ` - ${subName}` : ''}`;
    this.fetchArgs = args;
    this.status = error.status;
    this.cause = isErrorOfVsApi(error) ? error.data : error;
  }
}
